(() => {
  if (window.__venatV3) return;
  window.__venatV3 = true;

  const initCarousel = (root) => {
    if (!root || root.dataset.v3Ready) return;
    root.dataset.v3Ready = '1';
    const vp = root.querySelector('[data-v3-viewport]');
    const prev = root.querySelector('[data-v3-prev]');
    const next = root.querySelector('[data-v3-next]');
    if (!vp) return;
    const step = () => { const c = vp.querySelector('[data-v3-item]'); if (!c) return vp.clientWidth * 0.8; const gap = parseFloat(getComputedStyle(c.parentElement).columnGap) || 0; return c.getBoundingClientRect().width + gap; };
    const update = () => {
      const max = vp.scrollWidth - vp.clientWidth;
      if (prev) prev.disabled = vp.scrollLeft <= 2;
      if (next) next.disabled = vp.scrollLeft >= max - 2;
      root.querySelectorAll('[data-v3-arrows] .v3-arrow').forEach((a) => { a.style.visibility = max < 4 ? 'hidden' : 'visible'; });
    };
    if (prev) prev.addEventListener('click', () => vp.scrollBy({ left: -step(), behavior: 'smooth' }));
    if (next) next.addEventListener('click', () => vp.scrollBy({ left: step(), behavior: 'smooth' }));
    vp.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
  };

  const initHero = (root) => {
    if (!root || root.dataset.v3Ready) return;
    root.dataset.v3Ready = '1';
    const slides = Array.from(root.querySelectorAll('[data-v3-slide]'));
    const dots = Array.from(root.querySelectorAll('[data-v3-dot]'));
    if (slides.length < 2) return;
    const delay = (parseInt(root.dataset.autoplay, 10) || 0) * 1000;
    let index = 0; let timer = null;
    const show = (i) => {
      index = (i + slides.length) % slides.length;
      slides.forEach((s, k) => { const on = k === index; s.classList.toggle('is-active', on); s.setAttribute('aria-hidden', on ? 'false' : 'true'); s.toggleAttribute('inert', !on); });
      dots.forEach((d, k) => { d.classList.toggle('is-active', k === index); d.setAttribute('aria-current', k === index ? 'true' : 'false'); });
    };
    const stop = () => { if (timer) clearInterval(timer); timer = null; };
    const start = () => { stop(); if (delay > 0 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) timer = setInterval(() => show(index + 1), delay); };
    const p = root.querySelector('[data-v3-prev]');
    const n = root.querySelector('[data-v3-next]');
    if (p) p.addEventListener('click', () => { show(index - 1); start(); });
    if (n) n.addEventListener('click', () => { show(index + 1); start(); });
    dots.forEach((d, k) => d.addEventListener('click', () => { show(k); start(); }));
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    let sx = null;
    root.addEventListener('touchstart', (e) => { sx = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', (e) => { if (sx === null) return; const dx = e.changedTouches[0].clientX - sx; sx = null; if (Math.abs(dx) > 40) { show(index + (dx < 0 ? 1 : -1)); start(); } });
    document.addEventListener('shopify:block:select', (e) => { const i = slides.indexOf(e.target.closest ? e.target.closest('[data-v3-slide]') : null); if (i > -1) { show(i); stop(); } });
    show(0); start();
  };

  const refreshBubble = (data) => {
    const html = data && data.sections && data.sections['cart-icon-bubble'];
    const bubble = document.getElementById('cart-icon-bubble');
    if (!html || !bubble) return;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const inner = doc.querySelector('.shopify-section');
    if (inner) bubble.innerHTML = inner.innerHTML;
  };

  const rootUrl = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';

  const initAddForm = (form) => {
    if (!form || form.dataset.v3Ready) return;
    form.dataset.v3Ready = '1';
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const btn = form.querySelector('[type=submit]');
      const label = btn ? btn.innerHTML : '';
      if (btn) btn.disabled = true;
      try {
        const fd = new FormData(form);
        fd.append('sections', 'cart-icon-bubble');
        fd.append('sections_url', window.location.pathname);
        const res = await fetch(rootUrl() + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: fd });
        if (!res.ok) throw new Error('add');
        refreshBubble(await res.json());
        if (btn) { btn.textContent = form.dataset.addedLabel || 'Tillagd'; setTimeout(() => { btn.innerHTML = label; btn.disabled = false; }, 2000); }
      } catch (err) {
        form.submit();
      }
    });
  };

  const initRitual = (btn) => {
    if (!btn || btn.dataset.v3Ready) return;
    btn.dataset.v3Ready = '1';
    btn.addEventListener('click', async () => {
      const card = btn.closest('[data-v3-ritual]');
      if (!card) return;
      const status = card.querySelector('[data-v3-status]');
      const items = Array.from(card.querySelectorAll('[data-v3-variant]')).map((i) => ({ id: Number(i.dataset.v3Variant), quantity: 1 }));
      if (!items.length) return;
      btn.disabled = true;
      if (status) status.textContent = card.dataset.adding || '';
      try {
        const r = rootUrl();
        const res = await fetch(r + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
        if (!res.ok) throw new Error('add');
        const code = (card.dataset.code || '').trim();
        window.location.href = code ? r + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(r + 'cart') : r + 'cart';
      } catch (err) {
        btn.disabled = false;
        if (status) status.textContent = card.dataset.error || '';
      }
    });
  };

  const initGallery = (root) => {
    if (!root || root.dataset.v3Ready) return;
    root.dataset.v3Ready = '1';
    const main = root.querySelector('.v3-gallery__main img');
    const thumbs = Array.from(root.querySelectorAll('[data-v3-thumb]'));
    thumbs.forEach((t) => t.addEventListener('click', () => {
      if (!main) return;
      main.removeAttribute('srcset');
      main.src = t.dataset.src;
      if (t.dataset.srcset) main.srcset = t.dataset.srcset;
      main.alt = t.dataset.alt || '';
      thumbs.forEach((x) => { x.classList.toggle('is-active', x === t); x.setAttribute('aria-current', x === t ? 'true' : 'false'); });
    }));
  };

  const initQty = (root) => {
    if (!root || root.dataset.v3Ready) return;
    root.dataset.v3Ready = '1';
    const input = root.querySelector('input');
    root.querySelectorAll('[data-v3-step]').forEach((b) => b.addEventListener('click', () => {
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) + Number(b.dataset.v3Step));
    }));
  };

  const initAll = (scope) => {
    const s = scope || document;
    s.querySelectorAll('[data-v3-carousel]').forEach(initCarousel);
    s.querySelectorAll('[data-v3-hero]').forEach(initHero);
    s.querySelectorAll('[data-v3-add]').forEach(initAddForm);
    s.querySelectorAll('[data-v3-ritual-buy]').forEach(initRitual);
    s.querySelectorAll('[data-v3-gallery]').forEach(initGallery);
    s.querySelectorAll('[data-v3-qty]').forEach(initQty);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll());
  else initAll();
  document.addEventListener('shopify:section:load', (e) => initAll(e.target));
  window.venatV3Init = initAll;
})();
